import { Routes } from '@angular/router';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { languageGard } from 'src/app/shared/guards/language.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./navigation/navigation.component').then(m => m.NavigationComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'home'
            },
            {
                path: 'home',
                loadComponent: () => import('./homepage/homepage.component').then(m => m.HomepageComponent),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'accueil',
                loadComponent: () => import('./homepage/homepage.component').then(m => m.HomepageComponent),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'welkom',
                loadComponent: () => import('./homepage/homepage.component').then(m => m.HomepageComponent),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'login',
                loadChildren: () => import('../login/login.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'connexion',
                loadChildren: () => import('../login/login.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'aanmelden',
                loadChildren: () => import('../login/login.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },

            {
                path: 'error',
                loadChildren: () => import('../error/error.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'erreur',
                loadChildren: () => import('../error/error.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'fout',
                loadChildren: () => import('../error/error.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'contact',
                loadChildren: () => import('../contact/contact.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'contactezNous',
                loadChildren: () => import('../contact/contact.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'contacteerOns',
                loadChildren: () => import('../contact/contact.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'travelGuides',
                loadChildren: () => import('../products/guides/guides.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'guides',
                loadChildren: () => import('../products/guides/guides.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'gidsen',
                loadChildren: () => import('../products/guides/guides.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'maps',
                loadChildren: () => import('../products/maps/maps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'cartes',
                loadChildren: () => import('../products/maps/maps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'kaarten',
                loadChildren: () => import('../products/maps/maps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'globes',
                loadChildren: () => import('../products/globes/globes.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'globe',
                loadChildren: () => import('../products/globes/globes.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'wereldbollen',
                loadChildren: () => import('../products/globes/globes.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'wallmaps',
                loadChildren: () => import('../products/wallmaps/wallmaps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'cartesMurales',
                loadChildren: () => import('../products/wallmaps/wallmaps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'wandkaarten',
                loadChildren: () => import('../products/wallmaps/wallmaps.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'gifts',
                loadChildren: () => import('../products/gifts/gifts.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'cadeaux',
                loadChildren: () => import('../products/gifts/gifts.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'geschenken',
                loadChildren: () => import('../products/gifts/gifts.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'walking',
                loadChildren: () => import('../products/walking/walking.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'randonner',
                loadChildren: () => import('../products/walking/walking.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'wandelen',
                loadChildren: () => import('../products/walking/walking.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'search',
                loadChildren: () => import('../products/search/search.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'recherche',
                loadChildren: () => import('../products/search/search.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'zoeken',
                loadChildren: () => import('../products/search/search.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'campingGuidesMaps',
                loadChildren: () => import('../products/camping/camping.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'camping',
                loadChildren: () => import('../products/camping/camping.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'kamperen',
                loadChildren: () => import('../products/camping/camping.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'account',
                loadChildren: () => import('../account/account.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'account', alias: 'account' } }
                ]
            },
            {
                path: 'compte',
                loadChildren: () => import('../account/account.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'account', alias: 'account' } }
                ]
            },
            {
                path: 'gebruikersaccount',
                loadChildren: () => import('../account/account.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'account', alias: 'account' } }
                ]
            },
            {
                path: 'order',
                loadChildren: () => import('../order/order.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'order', alias: 'order' } }
                ]
            },
            {
                path: 'commande',
                loadChildren: () => import('../order/order.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'order', alias: 'order' } }
                ]
            },
            {
                path: 'bestellen',
                loadChildren: () => import('../order/order.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' },
                providers: [
                    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'order', alias: 'order' } }
                ]
            },
            {
                path: 'blog-en',
                loadChildren: () => import('../blog/blog.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'blog-fr',
                loadChildren: () => import('../blog/blog.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'blog-nl',
                loadChildren: () => import('../blog/blog.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            },
            {
                path: 'productdetails',
                loadChildren: () => import('../products/product-details/product-details.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'en' }
            },
            {
                path: 'detailsProduit',
                loadChildren: () => import('../products/product-details/product-details.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'fr' }
            },
            {
                path: 'detailsproduct',
                loadChildren: () => import('../products/product-details/product-details.routes').then(m => m.routes),
                canActivateChild: [languageGard],
                data: { lang: 'nl' }
            }
        ]
    },
    {
        path: 'legal',
        loadChildren: () => import('../legal/legal.routes').then(m => m.routes),
        canActivateChild: [languageGard],
        data: { lang: 'en' },
    },
    {
        path: 'juridique',
        loadChildren: () => import('../legal/legal.routes').then(m => m.routes),
        canActivateChild: [languageGard],
        data: { lang: 'fr' }
    },
    {
        path: 'legaal',
        loadChildren: () => import('../legal/legal.routes').then(m => m.routes),
        canActivateChild: [languageGard],
        data: { lang: 'nl' }
    },
    {
        path: '**',
        redirectTo: ''
    }
];
